module.exports = __webpack_public_path__ + "img/Newbie_Shield_03_Mage.23156e0f.png";